import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as R from 'runtypes';

import { URLS } from 'commons/app.constant';
import { SessionService as BaseSessionService, ResourceResponse, LoginSuccess, AuthService } from 'core';

const VerificationResponse = ResourceResponse(LoginSuccess);

const R_ForgotPasswordResponse = R.Record({
  message: R.String,
  loginConfirmationToken: R.String,
});
export type ForgotPasswordResponse = R.Static<typeof R_ForgotPasswordResponse>;

const ForgotPasswordOtpVerificationResponseDefn = R.Record({
  message: R.String,
  confirmationToken: R.String,
  passwordResetToken: R.String,
});
export type ForgotPasswordOtpVerificationResponse = R.Static<typeof ForgotPasswordOtpVerificationResponseDefn>;

@Injectable({
  providedIn: 'root',
})
export class SessionService extends BaseSessionService {
  private readonly authService = inject(AuthService);

  resendEmail(data: any): Observable<any> {
    const dataApi = {
      emailId: data.email,
    };
    return this.http.put(URLS.emailResend, dataApi);
  }

  forgotPassword(email: string): Observable<ResourceResponse<ForgotPasswordResponse>> {
    return this.http
      .get(URLS.forgotPasswordEmailSend + encodeURIComponent(email))
      .pipe(map(ResourceResponse(R_ForgotPasswordResponse).check));
  }

  verifyForgotPasswordOtp(confirmationToken: string, otp: string): Observable<ResourceResponse<ForgotPasswordOtpVerificationResponse>> {
    const dataApi = {
      confirmationToken,
      otp,
    };
    return this.http.post(URLS.forgotPasswordOTP, dataApi).pipe(map(ResourceResponse(ForgotPasswordOtpVerificationResponseDefn).check));
  }

  replaceForgottenPassword(user: any): Observable<any> {
    const dataApi = {
      confirmPassword: user.confirmPassword,
      passwordResetToken: this.authService.forgetPasswordToken,
      newPassword: user.password,
    };
    return this.http.put(URLS.forgetPassword, dataApi);
  }

  googleAuthQRCOde(): Observable<any> {
    return this.http.post(URLS.googleAuthAPI, {});
  }

  verification(verificationToken: string): Observable<ResourceResponse<LoginSuccess>> {
    return this.http.get(URLS.registerLinkVerify + verificationToken).pipe(map(VerificationResponse.check));
  }

  resendverificationLink(emailId: any): Observable<any> {
    const apiRequest = {
      emailId,
    };
    return this.http.put(URLS.resendLinkVerify, apiRequest);
  }
}
